import VendNumber, { vn } from 'vend-number'

// Lookup table generated based on datasets
// over @ https://github.com/vend/quickcash
const lookupTable = [
  [1, 5, 10, 20],
  [2, 5, 10, 20],
  [3, 5, 10, 20],
  [4, 5, 10, 20],
  [5, 10, 20, 50],
  [6, 10, 20, 50],
  [7, 10, 20, 50],
  [10, 8, 20, 50],
  [10, 20, 9, 50],
  [10, 20, 50, 100],
  [11, 20, 15, 21],
  [12, 20, 15, 50],
  [20, 13, 15, 50],
  [20, 14, 15, 50],
  [15, 20, 50, 100],
  [20, 16, 50, 100],
  [20, 17, 50, 100],
  [20, 18, 50, 100],
  [20, 19, 50, 100],
  [20, 50, 100, 40],
  [21, 25, 50, 30],
  [22, 25, 40, 30],
  [23, 25, 40, 30],
  [24, 25, 30, 40],
  [25, 40, 30, 50],
  [26, 40, 30, 50],
  [27, 30, 40, 50],
  [28, 30, 40, 50],
  [30, 40, 29, 50],
  [30, 40, 50, 100],
  [40, 31, 50, 100],
  [40, 32, 50, 35],
  [40, 33, 50, 35],
  [40, 34, 50, 35],
  [35, 40, 50, 100],
  [40, 36, 50, 100],
  [40, 37, 50, 100],
  [40, 38, 50, 100],
  [40, 50, 39, 100],
  [40, 50, 100, 45],
  [41, 50, 100, 45],
  [42, 50, 100, 45],
  [43, 50, 45, 100],
  [44, 45, 50, 100],
  [45, 50, 60, 100],
  [46, 50, 60, 100],
  [50, 47, 60, 100],
  [50, 48, 60, 100],
  [50, 60, 49, 100],
  [50, 60, 100, 55],
  [51, 60, 100, 55],
  [52, 60, 100, 55],
  [60, 53, 100, 55],
  [60, 54, 100, 55],
  [55, 60, 100, 70],
  [60, 56, 100, 70],
  [60, 57, 100, 70],
  [60, 58, 100, 70],
  [60, 59, 100, 70],
  [60, 100, 70, 80],
  [61, 100, 70, 65],
  [62, 100, 70, 65],
  [63, 100, 70, 65],
  [64, 100, 65, 70],
  [65, 100, 70, 80],
  [66, 100, 70, 80],
  [67, 70, 100, 80],
  [68, 70, 100, 80],
  [69, 70, 100, 80],
  [70, 100, 80, 90],
  [100, 80, 71, 75],
  [72, 100, 80, 75],
  [100, 80, 73, 75],
  [100, 80, 74, 75],
  [75, 100, 80, 90],
  [100, 80, 76, 90],
  [80, 100, 77, 90],
  [80, 100, 78, 90],
  [80, 100, 79, 90],
  [80, 100, 90, 500],
  [100, 81, 90, 85],
  [100, 82, 85, 90],
  [100, 83, 85, 90],
  [100, 84, 85, 90],
  [85, 100, 90, 105],
  [100, 86, 90, 101],
  [100, 87, 90, 107],
  [100, 88, 90, 108],
  [100, 89, 90, 95],
  [90, 100, 110, 99],
  [100, 91, 101, 95],
  [100, 92, 102, 95],
  [100, 93, 95, 103],
  [100, 94, 95, 110],
  [95, 100, 110, 105],
  [100, 96, 110, 101],
  [100, 97, 110, 200],
  [100, 98, 110, 200],
  [100, 99, 110, 109],
  [100, 110, 200, 101],
  [101, 120, 105, 110],
  [102, 105, 120, 110],
  [103, 105, 120, 110],
  [104, 105, 110, 120],
  [105, 110, 120, 150],
  [106, 120, 110, 150],
  [107, 110, 120, 200],
  [108, 110, 120, 200],
  [109, 110, 120, 150],
  [110, 120, 150, 200],
  [111, 120, 150, 200],
  [112, 120, 115, 200],
  [120, 113, 115, 200],
  [120, 114, 115, 150],
  [115, 120, 200, 150],
  [120, 116, 150, 200],
  [120, 117, 150, 200],
  [120, 118, 150, 200],
  [120, 119, 150, 200],
  [120, 150, 200, 130],
  [121, 200, 130, 125],
  [122, 125, 150, 140],
  [123, 125, 140, 130],
  [124, 125, 140, 130],
  [125, 140, 130, 150],
  [126, 140, 130, 150],
  [127, 130, 140, 150],
  [128, 140, 130, 150],
  [129, 130, 140, 150],
  [130, 140, 150, 200],
  [140, 131, 150, 200],
  [132, 140, 200, 150],
  [140, 133, 150, 200],
  [140, 134, 150, 200],
  [135, 140, 150, 200],
  [136, 140, 150, 200],
  [140, 137, 150, 200],
  [140, 138, 150, 200],
  [139, 140, 150, 200],
  [140, 150, 200, 500],
  [141, 150, 200, 160],
  [142, 150, 200, 145],
  [143, 150, 200, 145],
  [144, 150, 200, 145],
  [145, 150, 160, 200],
  [146, 150, 160, 200],
  [150, 147, 160, 200],
  [148, 150, 200, 160],
  [149, 150, 160, 200],
  [150, 160, 200, 500],
  [151, 160, 200, 155],
  [152, 160, 200, 155],
  [153, 160, 200, 155],
  [154, 160, 200, 155],
  [155, 160, 200, 170],
  [156, 160, 200, 170],
  [160, 157, 200, 170],
  [158, 160, 200, 170],
  [159, 160, 200, 170],
  [160, 200, 170, 161],
  [161, 200, 170, 180],
  [162, 200, 170, 165],
  [163, 200, 180, 165],
  [164, 200, 170, 165],
  [165, 200, 170, 180],
  [166, 200, 170, 180],
  [167, 170, 200, 180],
  [168, 200, 170, 180],
  [169, 200, 170, 180],
  [170, 200, 180, 190],
  [171, 200, 180, 172],
  [172, 180, 200, 175],
  [200, 173, 180, 175],
  [174, 200, 180, 175],
  [175, 200, 180, 190],
  [176, 180, 200, 190],
  [200, 177, 180, 190],
  [178, 180, 200, 190],
  [179, 200, 180, 190],
  [180, 200, 190, 500],
  [200, 181, 190, 185],
  [200, 182, 185, 190],
  [200, 183, 185, 190],
  [200, 184, 185, 190],
  [185, 200, 190, 205],
  [186, 200, 190, 500],
  [200, 187, 190, 500],
  [200, 188, 190, 204],
  [189, 200, 190, 195],
  [190, 200, 500, 208],
  [200, 191, 195, 201],
  [200, 192, 500, 195],
  [200, 193, 195, 210],
  [200, 194, 195, 500],
  [195, 200, 210, 500],
  [200, 196, 500, 201],
  [200, 197, 500, 210],
  [198, 200, 208, 210],
  [199, 200, 220],
  [200, 500, 210, 220],
  [201, 205, 210, 220],
  [202, 205, 210, 220],
  [203, 205, 220, 210],
  [204, 205, 220, 210],
  [205, 210, 220, 250],
  [206, 220, 210, 250],
  [207, 220, 210, 250],
  [208, 210, 220, 300],
  [209, 210, 220, 250],
  [210, 220, 250, 300],
  [211, 220, 215, 212],
  [212, 220, 215, 300],
  [213, 220, 215, 250],
  [220, 214, 300, 215],
  [215, 220, 250, 300],
  [216, 220, 300, 500],
  [220, 217, 250, 300],
  [220, 218, 300, 250],
  [219, 220, 250, 300],
  [220, 250, 300, 500],
  [221, 300, 500, 225],
  [222, 225, 300, 230],
  [223, 225, 250, 240],
  [224, 225, 240, 250],
  [225, 250, 240, 230],
  [226, 240, 230, 250],
  [227, 230, 240, 250],
  [228, 240, 230, 300],
  [229, 230, 240, 250],
  [230, 240, 250, 300],
  [231, 240, 300, 250],
  [232, 240, 300, 250],
  [233, 240, 235, 250],
  [234, 240, 250, 300],
  [235, 240, 250, 300],
  [236, 240, 250, 300],
  [237, 240, 250, 300],
  [238, 240, 250, 300],
  [239, 240, 250, 300],
  [240, 250, 300, 500],
  [241, 300, 250, 260],
  [242, 250, 300, 260],
  [243, 250, 300, 260],
  [244, 250, 245, 260],
  [245, 250, 300, 260],
  [246, 250, 300, 260],
  [247, 260, 250, 300],
  [248, 250, 260, 300],
  [249, 250, 300, 260],
  [250, 260, 300, 500],
  [251, 300, 260, 252],
  [252, 300, 260, 255],
  [253, 300, 260, 255],
  [254, 260, 300, 255],
  [255, 260, 300, 270],
  [256, 260, 300, 261],
  [260, 257, 300, 306],
  [258, 260, 300, 270],
  [259, 260, 300, 265],
  [260, 300, 270, 310],
  [261, 300, 280, 265],
  [262, 300, 270, 280],
  [263, 270, 300, 280],
  [264, 300, 270, 265],
  [265, 300, 270, 280],
  [266, 270, 300, 280],
  [300, 267, 270, 280],
  [268, 270, 300, 280],
  [269, 300, 270, 280],
  [270, 300, 280, 500],
  [271, 300, 280, 275],
  [272, 280, 300, 275],
  [273, 300, 280, 275],
  [274, 300, 280, 275],
  [275, 300, 280, 285],
  [276, 300, 280, 281],
  [277, 280, 300, 290],
  [278, 300, 280, 500],
  [279, 300, 280, 290],
  [280, 300, 500, 290],
  [281, 300, 290, 285],
  [282, 300, 285, 500],
  [300, 283, 285, 290],
  [300, 284, 285, 290],
  [285, 300, 290],
  [286, 300, 500],
  [300, 287, 290, 500],
  [288, 300, 290, 303],
  [289, 300, 290, 500],
  [290, 300, 400, 500],
  [300, 291, 301],
  [292, 300, 295, 400],
  [300, 293, 295],
  [294, 300, 295, 304],
  [295, 300, 310],
  [300, 296],
  [297, 300],
  [298, 300, 310],
  [299, 300, 500, 310],
  [300, 500],
  [301, 320, 305, 400],
  [302, 305, 320, 400],
  [303, 305, 310, 320],
  [304, 305, 320, 350],
  [305, 310, 320, 400],
  [306, 310, 320, 311],
  [307, 310, 320, 350],
  [308, 310, 320, 400],
  [309, 310, 320, 400],
  [310, 320, 350, 400],
  [311, 320, 400, 325],
  [312, 320, 400, 315],
  [320, 313, 323, 350],
  [314, 320, 400, 315],
  [315, 320, 350, 400],
  [316, 320, 400, 350],
  [317, 320, 400, 500],
  [318, 320, 350, 400],
  [319, 320, 350, 400],
  [320, 350, 400, 500],
  [321, 350, 340, 400],
  [322, 325, 400, 350],
  [323, 340, 330, 325],
  [324, 340, 400, 325],
  [325, 340, 400, 330],
  [326, 340, 400, 330],
  [327, 340, 350, 330],
  [328, 330, 350, 340],
  [329, 340, 330, 350],
  [330, 340, 400, 350],
  [331, 340, 400, 341],
  [332, 340, 350, 500],
  [333, 340, 400, 335],
  [334, 340, 400, 335],
  [335, 350, 340, 400],
  [336, 400, 350, 340],
  [337, 340, 350, 400],
  [338, 340, 350, 400],
  [339, 340, 350, 400],
  [340, 350, 400, 500],
  [341, 400, 350, 360],
  [342, 400, 345, 350],
  [343, 350, 400, 500],
  [344, 345, 350, 360],
  [345, 350, 400, 360],
  [346, 350, 360],
  [347, 350, 360, 400],
  [348, 350, 360, 400],
  [349, 350, 360, 400],
  [350, 500, 360, 400],
  [351, 360, 400],
  [352, 360, 400],
  [353, 360, 355, 400],
  [354, 400, 360, 355],
  [355, 400, 360, 500],
  [360, 356, 400, 500],
  [357, 400, 360, 370],
  [358, 400, 360],
  [359, 360, 400, 370],
  [360, 400, 500, 370],
  [361, 400, 370, 380],
  [362, 400, 500, 370],
  [363, 400, 380, 365],
  [364, 400, 380, 370],
  [365, 380, 400, 370],
  [366, 400, 370, 367],
  [367, 370, 380, 400],
  [368, 400, 370, 380],
  [369, 400, 370, 380],
  [370, 380, 400, 500],
  [371, 400, 380, 375],
  [372, 380, 400, 375],
  [373, 400, 375, 380],
  [374, 400, 380, 420],
  [375, 380, 400, 390],
  [376, 400, 380],
  [377, 380, 400],
  [378, 400, 380, 390],
  [379, 380, 400],
  [380, 500, 400],
  [381, 400, 500],
  [382, 400, 500, 385],
  [400, 383, 390, 500],
  [384, 400, 385, 390],
  [385, 400, 390],
  [386, 400, 390, 500],
  [400, 387, 390],
  [388, 400, 390, 500],
  [389, 400, 390, 450],
  [390, 400, 500],
  [391, 400],
  [392, 400, 402],
  [393, 400, 395, 403],
  [400, 394, 500],
  [395, 400],
  [396, 400],
  [400, 397],
  [398, 400, 500],
  [399, 400, 500],
  [400, 500, 410],
  [401, 500],
  [402, 405, 420, 500],
  [403, 420, 405],
  [404, 410, 420],
  [405, 410, 420, 450],
  [406, 420],
  [407, 420, 500, 410],
  [408, 420, 410],
  [409, 420, 410, 450],
  [410, 420, 450, 500],
  [411, 415, 421],
  [412, 420, 415],
  [413, 500, 420],
  [414, 420, 500, 450],
  [415, 420, 500, 450],
  [416, 450],
  [417, 420, 500, 450],
  [418, 420, 500],
  [419, 420, 450, 500],
  [420, 500, 450],
  [421],
  [422, 425, 430, 500],
  [423, 425, 440, 450],
  [424, 425, 430, 500],
  [425, 430, 440, 450],
  [426, 430, 440, 450],
  [427, 440, 450, 430],
  [428, 440, 500, 430],
  [429, 430, 450, 440],
  [430, 440, 500],
  [431, 440, 450, 451],
  [432, 500, 440, 450],
  [433, 500, 450, 435],
  [434, 440, 500, 435],
  [435, 440, 500, 450],
  [436, 440, 500],
  [437, 440, 450],
  [438, 440, 450],
  [439, 450, 440, 500],
  [440, 500, 450, 460],
  [500, 441, 450],
  [442, 450, 500],
  [443, 445, 450, 500],
  [444, 445, 450, 500],
  [445, 460, 500, 450],
  [446, 450, 500, 460],
  [447, 450, 460],
  [448, 450, 460],
  [449, 450, 500, 460],
  [450, 500, 460],
  [451, 500],
  [452, 460],
  [453, 455, 470, 500],
  [460, 454, 470, 500],
  [455, 460, 500],
  [456, 500],
  [457, 460, 500],
  [458, 460],
  [459, 500, 460, 470],
  [460, 500],
  [461, 500, 465],
  [462, 465, 500],
  [463, 500, 470],
  [464, 500, 470, 480],
  [465, 500],
  [466, 500, 467, 470],
  [467, 500, 470, 480],
  [468, 500, 480, 470],
  [469, 480, 500],
  [470, 500, 480],
  [500, 471],
  [472, 500],
  [473, 480, 500],
  [474, 500, 480],
  [475, 500, 480],
  [476, 500, 480],
  [477, 480, 500],
  [478, 480, 500],
  [479, 480, 500],
  [480, 500],
  [500, 481, 482, 490],
  [500, 482, 485, 490],
  [483, 490, 500],
  [484, 500, 485],
  [485, 500, 490],
  [486, 490, 500],
  [487, 500],
  [488, 500, 490],
  [489, 500, 490],
  [490, 500],
  [491, 500],
  [492, 500],
  [500, 493, 495],
  [494, 500],
  [495, 500],
  [496, 500],
  [497, 500],
  [498, 500],
  [499, 500],
  [500],
]

/**
 * Returns quick cash suggestions
 * based on a lookup table generated by looking at actual payment data
 *
 * @method getQuickCashSuggestions
 *
 * @param {Object} data
 *
 * @param  [amount] {Integer}
 *         The amount we're checking against
 *
 * @return {Array<VendNumber>} Three suggestions as VendNumbers
 */
export const getQuickCashSuggestions = (amount: number): VendNumber[] => {
  // Grab suggestions from lookup table
  let suggestions = lookupTable[Math.ceil(amount) - 1]
  // Check if suggestions for the amount are defined
  if (suggestions === undefined) {
    return []
  }
  // If amount is rounded
  if (amount % 1 === 0) {
    // Return the array without the exact match
    // As this case is automatically included in the modal
    suggestions = suggestions.filter(s => s !== amount)
  }

  // Return the three most likely outcomes
  return suggestions
    .slice(0, 3)
    .sort((a, b) => a - b) // Sort by size for better UX
    .map(s => vn(s))
}
